import { randomString } from '@/utils/tools';

/**
 * 生成用于神策与 Snowplow 业务埋点对账的 32 位事件 ID。
 */
export function generateEventId(): string {
  return randomString(32).slice(0, 32);
}
